import {
  Directive,
  ElementRef,
  inject,
  output
} from '@angular/core';

@Directive({
    selector: 'form[exlFocusInvalid]',
    host: {
        '(submit)': 'focusInvalidOnSumbit()',
    },
    standalone: true,
})
export class FocusInvalidFormFieldDirective {
    private el = inject(ElementRef);

    readonly validationComplete = output<any>();

    focusInvalidOnSumbit() {
        // both form-field container and the element (e.g. input) have 'ng-invalid' class
        const invalidField = this.el.nativeElement.querySelector(
            'input.ng-invalid, .mat-mdc-checkbox.ng-invalid input, mat-select.ng-invalid, quill-editor.ng-invalid .ql-editor[contenteditable=true]',
        ) as HTMLElement;
        setTimeout(() => {
            invalidField?.focus();
            if (!invalidField) {
                this.validationComplete.emit(null);
            }
        }, 200);
    }
}
